<script setup lang="ts">
/**
 * LoadingSpinner — Reusable loading indicator
 * Compact spinner with optional label text.
 */
defineProps<{
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}>();
</script>

<template>
  <div class="spinner-wrap" :class="`spinner--${size ?? 'md'}`">
    <div class="spinner" />
    <span v-if="label" class="spinner-label">{{ label }}</span>
  </div>
</template>

<style scoped>
.spinner-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
}

.spinner {
  border: 2px solid rgba(74, 158, 255, 0.15);
  border-top-color: var(--accent-blue);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

.spinner--sm .spinner {
  width: 16px;
  height: 16px;
  border-width: 1.5px;
}

.spinner--md .spinner {
  width: 24px;
  height: 24px;
}

.spinner--lg .spinner {
  width: 36px;
  height: 36px;
  border-width: 3px;
}

.spinner-label {
  font-size: 0.78rem;
  color: var(--text-secondary);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
